'use strict';

(function () {
    'use strict';

    angular.module('app.widgets').directive('uiSelectPlaceholder', Directive);

    /* @ngInject */
    function Directive() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            bindToController: true,
            controller: ControllerController,
            controllerAs: 'vm',
            require: 'uiSelect',
            link: { post: postLink },
            restrict: 'A'
            // scope: {
            //     uiSelectPlaceholder : '@'
            // }
        };
        return directive;

        function postLink(scope, element, attrs, $select) {
            scope.$watch(function () {
                return $select.searchInput && $select.placeholder;
            }, function (newValue, oldValue) {
                angular.element($select.searchInput).attr('placeholder', $select.placeholder);
                $select.searchInput.attr('placeholder', $select.placeholder);
            });
        }
    }
    /* @ngInject */
    function ControllerController() {}
})();